import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@rtkwlf/fenrir-react';
import { faPencil } from '@rtkwlf/pro-solid-svg-icons/faPencil';
import { useTranslation } from 'react-i18next';

import { OPTIMISTIC_UPDATE_PREFIX } from '../../../constants';
import { ScanCredentialsDialog } from '../../../scan-credentials-dialog/scan-credentials-dialog';
import type { CredentialedScanningRow } from '../../../types';

type EditCredentialButtonProps = {
  credentialedScanningRow: CredentialedScanningRow;
  scannerId: string;
  isDisabled?: boolean;
};

export const EditCredentialButton: React.FC<EditCredentialButtonProps> = ({
  credentialedScanningRow,
  scannerId,
  isDisabled,
}) => {
  const { t } = useTranslation('telemetryScannerConfig');

  const [showDialog, setShowDialog] = useState<boolean>(false);

  return (
    <>
      <Button
        marginLeft="auto"
        iconLeft={<FontAwesomeIcon icon={faPencil} />}
        variant="tertiary"
        onClick={() => setShowDialog(true)}
        isDisabled={
          isDisabled ||
          credentialedScanningRow.id.includes(OPTIMISTIC_UPDATE_PREFIX)
        }
      >
        {t('actions.edit')}
      </Button>
      {showDialog && (
        <ScanCredentialsDialog
          scannerId={scannerId}
          onClose={() => {
            setShowDialog(false);
          }}
          credentialedScanningRowData={credentialedScanningRow}
        />
      )}
    </>
  );
};
